export const hoseasonsInspiration = {
    leftSection: {
        title: "What's new",
        footerLink: {
            title: 'See All Holiday Guides',
            href: '/blog',
        },
        isMultiColumns: false,
        links: [
            {
                link: {
                    title: 'Things to do in Cornwall in the Rain',
                    href: '/blog/things-to-do-cornwall-rain',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Best Beaches in Cornwall',
                    href: '/blog/best-beaches-cornwall',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: '20 Best Walks in Scotland',
                    href: '/blog/best-walks-scotland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: '15 Best Beaches in Scotland',
                    href: '/blog/best-beaches-scotland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: '10 Best Beaches in Wales',
                    href: '/blog/best-beaches-wales',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Discover Majestic Mountains in Wales',
                    href: '/blog/mountains-in-wales',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
    rightSection: {
        title: 'Holiday Collections',
        footerLink: {
            title: 'See All Holiday Collections',
            href: '/collections',
        },
        isImageLinks: true,
        links: [
            {
                title: 'Dog-friendly holidays',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/5PwGlRLh905ALauKveTqMY/1b79c1c8d1ec42ddad66a90d02821dc7/MARM-01D_19.jpg?w=191&h=142&fm=webp',
                    alt: 'Dog-friendly holidays',
                },
                link: {
                    href: '/collections/dog-friendly',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Family holidays',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/6vO9ErqNapyUWCycuw2bv/7c368cf2592a33d5feaf2c3bf962af7f/BURN-06E_22.jpg?w=191&h=142&fm=webp',
                    alt: 'Family holidays',
                },
                link: {
                    href: '/collections/family-holidays',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Hot tub breaks',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/3jDEqR8a3bL4CKwX1uJGfU/012c500433f7b4d9b6e03b93ea22dc64/cedar_retreats.png?w=191&h=142&fm=webp',
                    alt: 'Hot tub breaks',
                },
                link: {
                    href: '/collections/hot-tubs',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Group holidays',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/474xuecd5pdGgtVTKcS1je/8f70c01aeb98f0717205602aac84b32d/Henelle_Hall_2019_204__1_.webp?w=191&h=142&fm=webp',
                    alt: 'Group holidays',
                },
                link: {
                    href: '/collections/group-holidays',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Last-minute caravan holidays',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/5IUvAa5xNXKdaXbErqzkJu/3d95729b6530af1275e217f7ab26ee89/PBAM-11B_23.jpg?w=191&h=142&fm=webp',
                    alt: 'Last-minute caravan holidays',
                },
                link: {
                    href: '/collections/last-minute-deals',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Weekend breaks',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/4A8aNal6UarwDGfi6oVVfC/6ec32eb169e95396db91ac216752f65a/Henelle_Hall_2019_1059.jpg?w=191&h=142&fm=webp',
                    alt: 'Weekend breaks',
                },
                link: {
                    href: '/collections/weekend-breaks',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
};
export const hoseasonsDestinations = {
    leftSection: {
        title: 'Explore our destinations',
        isMultiColumns: false,
        links: [
            {
                link: {
                    title: 'England',
                    href: '/england',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Scotland',
                    href: '/scotland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Wales',
                    href: '/wales',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
    rightSection: {
        title: 'Most popular destinations',
        isImageLinks: false,
        links: [
            {
                title: 'Anglesey',
                link: {
                    href: '/wales/anglesey',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Ayrshire',
                link: {
                    href: '/scotland/ayrshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Cornwall',
                link: {
                    href: '/england/cornwall',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'County Conwy',
                link: {
                    href: '/wales/county-conwy',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Cumbria',
                link: {
                    href: '/england/cumbria',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Derbyshire',
                link: {
                    href: '/england/derbyshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Devon',
                link: {
                    href: '/england/devon',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Dorset',
                link: {
                    href: '/england/dorset',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Dumfries & Galloway',
                link: {
                    href: '/scotland/dumfries-and-galloway',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Edinburgh & the Lothians',
                link: {
                    href: '/scotland/edinburgh-and-the-lothians',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Isle of Wight',
                link: {
                    href: '/england/isle-of-wight',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Lincolnshire',
                link: {
                    href: '/england/lincolnshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Norfolk',
                image: {
                    src: '?',
                    alt: 'Norfolk',
                },
                link: {
                    href: '/england/norfolk',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Pembrokeshire',
                image: {
                    src: '?',
                    alt: 'Pembrokeshire',
                },
                link: {
                    href: '/wales/pembrokeshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Powys',
                link: {
                    href: '/wales/powys',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Scottish Highlands',
                link: {
                    href: '/scotland/highlands',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Somerset',
                link: {
                    href: '/england/somerset',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Yorkshire',
                link: {
                    href: '/england/yorkshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
};
//# sourceMappingURL=en.js.map